import {
    createSupportTicket,
    getMySupportTickets
} from "../../services/supportService";

import {
    CREATE_SUPPORT_TICKET_REQUEST,
    CREATE_SUPPORT_TICKET_SUCCESS,
    CREATE_SUPPORT_TICKET_FAILURE,
    GET_SUPPORT_TICKETS_REQUEST,
    GET_SUPPORT_TICKETS_SUCCESS,
    GET_SUPPORT_TICKETS_FAILURE,
} from "./types";

export const createSupportTicketAction =
    (formData) =>
    async (dispatch) => {
        dispatch({
            type: CREATE_SUPPORT_TICKET_REQUEST,
        });

        const response =
            await createSupportTicket(
                formData
            );

        if (
            response?.success
        ) {
            dispatch({
                type: CREATE_SUPPORT_TICKET_SUCCESS,
                payload:
                    response.data,
            });

            return response;
        }

        dispatch({
            type: CREATE_SUPPORT_TICKET_FAILURE,
            payload:
                response?.error,
        });

        return response;
    };

export const fetchMySupportTickets =
    (
        page = 1,
        size = 10
    ) =>
    async (dispatch) => {
        dispatch({
            type: GET_SUPPORT_TICKETS_REQUEST,
        });

        const response =
            await getMySupportTickets(
                page,
                size
            );

        if (
            response?.success
        ) {
            dispatch({
                type: GET_SUPPORT_TICKETS_SUCCESS,
                payload:
                    response.data,
            });

            return response;
        }

        dispatch({
            type: GET_SUPPORT_TICKETS_FAILURE,
            payload:
                response?.error,
        });

        return response;
    };